import { useCallback } from 'react';
import { useApolloClient } from '@apollo/react-hooks';

import { GET_TREADWELL_DRIVER_PERSONA_OPTIONS } from '../../graphql/treadwell-driver-types-queries';

import { FuelTypeEnum, VehicleCategory } from '../../types/graphql-types';

export default function useTreadwellPersonas() {
  const client = useApolloClient();

  const getTreadwellPersonaData = useCallback(
    selectedFitment =>
      client
        .query({
          fetchPolicy: 'network-only',
          query: GET_TREADWELL_DRIVER_PERSONA_OPTIONS,
          variables: {
            fuelType: selectedFitment?.fuelType || FuelTypeEnum.Ice,
            vehicleCategory:
              selectedFitment?.vehicleCategory?.replace(/ /g, '_') ||
              VehicleCategory.SedanCsmpEconomy
          }
        })
        .then(({ data }) => {
          const personasList =
            data?.recommendationQueries?.treadwellPersonas?.contentSlots[0]
              ?.cmsComponents;
          const prioritiesList =
            data?.recommendationQueries?.treadwellCustomPriorities
              ?.cmsComponents;
          return {
            personasList,
            prioritiesList
          };
        }),
    [client]
  );

  return {
    getTreadwellPersonaData
  };
}
